import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import moment from "moment";
import classNames from 'classnames';
import Button from 'material-ui/Button';
import KeymanAttribute from '../parts/KeymanAttribute';
import { TimelineLabelType, DashboardTimelineType } from '../../../constants/ComponentTypes';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: "14px 0 15px",
    borderBottom: "1px solid #ECEDEF",
  },

  instructedAt: {
    fontSize: "11px",
    color: "#71737B",
  },

  letterOrder: {
    display: 'flex',
    alignItems: 'center',
  },

  timeline: {
    display: 'flex',
    width: "334px",
    justifyContent: 'space-around',
  },

  status: {
    display: 'flex',
    width: "50%",
    justifyContent: 'space-around',
  },

  update: {
    display: 'flex',
    width: "50%",
    justifyContent: 'space-around',
  },

  timelineLabel: {
    fontSize: '11px',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    width: "115px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },
});

class AddressItem extends React.Component {
  render() {
    const { classes, item, statusSelected, location, dateSelected, keyword } = this.props;
    let color, text;
    const target = Object.values(TimelineLabelType).find(label => label.value === item.status_label_type);
    if (target) {
      color = target.color;
      text = target.text;
    }

    // ステータス別キーマン一覧ページの場合のみページ遷移して「戻る」ボタンで戻った時に
    // 遷移前のステータスを表示するためにstateに設定値を含める
    let state = {
      ownerType: this.props.ownerType,
      dateSelectedValue: dateSelected.value,
      path: location.pathname,
      keyword: keyword
    };
    if (location.pathname === ('/order-dashboard' + DashboardTimelineType.BY_FOLLOW_CALL_STATUS.path)) {
      state = {
        ownerType: this.props.ownerType,
        statusSelected: statusSelected,
        dateSelectedValue: dateSelected.value,
        keyword: keyword
      };
    }

    return (
      <div className={classes.root} key={this.props.key}>
        <div className={classes.letterOrder}>
          <KeymanAttribute item={item} style={{ width: "293px", marginRight: "87px" }} />
        </div>
        <div className={classes.timeline}>
          <div className={classes.status}>
            <Typography className={classes.timelineLabel} style={{ color: color }}>
              {text}
            </Typography>
          </div>
          <div className={classes.update}>
            <Typography>
              {moment(item.stated_at).format("YYYY/MM/DD") + "更新"}
            </Typography>
          </div>
        </div>
        <Button className={classNames(classes.btn, classes.btnEnable)}
          onClick={() => {
            if (!this.props.isDemo) {
              this.props.goTo(
                `${item.executive_person_id
                  ? "/executive-list/" + item.executive_person_id
                  : "/house-list/" + item.address_id
                }/timeline`, state
              );
            } else {
              this.props.togglePlanDialog();
            }
          }}
        >
          タイムライン
        </Button>
      </div>
    )
  }
}

AddressItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  key: PropTypes.number,
  goTo: PropTypes.func.isRequired,
  statusSelected: PropTypes.object.isRequired,
  dateSelected: PropTypes.object.isRequired,
  ownerType: PropTypes.string.isRequired,
  isDemo: PropTypes.bool,
  togglePlanDialog: PropTypes.func,
  location: PropTypes.object,
  keyword: PropTypes.string,
};

export default withRouter(withStyles(styles)(AddressItem));



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/items/AddressItem.jsx